/**
 * EmailAuditoria
 */
import {$, HttpBody, ID, Resource, ResponseSerialize, TAG} from 'simpli-web-sdk'
import EmailAuditoriaSchema from '@/schema/EmailAuditoria.schema'
import Responsavel from '@/model/resource/Responsavel'
import EmailAuditoriaNivel from '@/model/resource/EmailAuditoriaNivel'

export default class EmailAuditoria extends Resource {

  static async sendAuditoriaEmail(
      idCargas: ID[],
      emailAuditoria: EmailAuditoria,
      all: boolean ,
      allTiers: boolean,
      spinner = 'sendAuditoriaEmail',
  ) {
    return await $.await.run(() => new HttpBody(Number).POST(`/user/email-auditoria/disparar-emails`, {
      idCargas, emailAuditoria, all, allTiers,
    }), spinner)
  }

  get $schema() {
    return EmailAuditoriaSchema(this)
  }

  get $id() {
    return this.idEmailAuditoriaPk
  }
  set $id(val: ID) {
    this.idEmailAuditoriaPk = val
  }

  get $tag() {
    return this.nomeGrupo
  }
  set $tag(val: TAG) {
    this.nomeGrupo = val
  }

  static async persistLoteEmailAuditoria(
      listToPersist: EmailAuditoria[], spinner = 'persistEmailAuditoria') {
    const fetch = async () => {
      return await new HttpBody(Number).POST(`/user/lote-email-auditoria`, listToPersist)
    }

    return await $.await.run(fetch, spinner)
  }
  readonly $name: string = 'EmailAuditoria'

  readonly $endpoint: string = '/user/email-auditoria{/id}'

  idEmailAuditoriaPk: ID = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  nomeGrupo: string = ''

  emailAuditoriaNivel: EmailAuditoriaNivel = new EmailAuditoriaNivel()

  idResponsavelFk: ID = 0

  async persistEmailAuditoria(spinner = 'persistEmailAuditoria') {
    const fetch = async () => {
      await this.validate()
      return await this.POST(`/user/email-auditoria`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getEmailAuditoria(id: number | string, spinner = 'getEmailAuditoria') {
    const fetch = async () => await this.GET(`/user/email-auditoria/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
